"use strict";

EWS.Ready(() => {
    if (UserType !== "Guest") {
        // InitEncompassHelp();
    }
});

function InitEncompassHelp() {
    const pageHeader = document.querySelector("#Header .Inner");

    if (pageHeader) {
        const ecpHelpButton = EC_Fmt.HtmlStrToElement("<div class=\"IconButton ecp-help-button\"><span class=ews-icon-emquicktour></span></div>");
        pageHeader.appendChild(ecpHelpButton);

        ecpHelpButton.addEventListener("click", (event) => {
            let helpMenu = document.querySelector("#ecp-help-menu");

            if (!helpMenu) {
                helpMenu = WriteEncompassHelpMenu();
                WriteCurrentHelpResources();
            }

            helpMenu.ShowMenu(event.currentTarget);
        });
    }
}

function WriteEncompassHelpMenu() {
    let href = "API?APICommand=Distributor_Requests_Support";
    if (Distributor === "InfrontSmart") {
        href = "Home?DashboardID=158744";
    }

    const html = "<ecp-menu id=ecp-help-menu>"
        + "<ecp-list>"
        + "<ecp-list-item>"
        + "<ecp-input id=ecp-help-dialog-input type=text icon=ews-icon-search placeholder=\"Search help resources\" style=width:100%></ecp-input>"
        + "</ecp-list-item>"
        + "<div class=ecp-help-empty></div>"
        + "<div class=ecp-help-content style=min-height:100px></div>"
        + "<ecp-list-item>"
        + "<ecp-list-item-title style=\"padding:0 16px;font-size:14px;line-height:40px\">Can't find what you're looking for?</ecp-list-item-title>"
        + "<ecp-list-action>"
        + `<ecp-btn type=primary href=${href}>Ask a question</ecp-btn>`
        + "</ecp-list-action>"
        + "</ecp-list-item>"
        + "</ecp-list>"
        + "</ecp-menu>";

    const helpMenu = EC_Fmt.HtmlStrToElement(html);
    document.body.appendChild(helpMenu);

    EC_Fmt.AfterInput(helpMenu.querySelector("input#ecp-help-dialog-input"), 0, 350, async (input, search) => {
        if (search.length >= 3) {
            const myRequest = new ECP.EC_Request("EncompassHelp_HelpResourcesSearch");
            myRequest.AddRequestVariable("SearchStr", search);

            const result = await myRequest.Submit();
            WriteEncompassHelpContent(result, search);
        } else if (search.length === 0) {
            WriteCurrentHelpResources();
        }
    });

    return helpMenu;
}

async function WriteCurrentHelpResources() {
    const timer = setTimeout(() => {
        ECP.Dialog.ShowLoading("", document.querySelector("#ecp-help-menu .ecp-help-content"));
    }, 1000);

    const myRequest = new ECP.EC_Request("EncompassHelp_GetCurrentHelpResources");
    myRequest.AddRequestVariable("DashboardID", Settings.DashboardID);

    if (Settings.DashboardID === ECP.CommonDashboards.TableView) {
        myRequest.AddRequestVariable("TableName", EC_Fmt.GetPageParameter("TableName"));
    }

    const result = await myRequest.Submit();

    clearTimeout(timer);
    document.querySelector("#ecp-help-menu .ecp-help-content").style.minHeight = "auto";

    WriteEncompassHelpContent(result);
}

function WriteEncompassHelpContent(result, search) {
    const helpContent = document.querySelector("#ecp-help-menu .ecp-help-content");
    const helpEmpty = document.querySelector("#ecp-help-menu .ecp-help-empty");
    helpContent.innerHTML = "";
    helpEmpty.innerHTML = "";

    const AvailableResourceLength = result.AvailableResourceLength;
    const ResourceResult = result.ResourceResult;
    let html = "";
    let ApplicationID = 0;

    if (ResourceResult && ResourceResult.length > 0) {
        for (let i = 0; i < ResourceResult.length; i++) {
            const ApplicationObj = ResourceResult[i];
            ApplicationID = ApplicationObj.ApplicationID;

            if (EC_Fmt.isNull(search)) {
                html += "<ecp-list-item style=background-color:#F6F6F6><ecp-list-item-content>";
                html += `<ecp-list-item-title style=font-weight:700>${ApplicationObj.Application}</ecp-list-item-title>`;
                html += `<ecp-list-item-subtitle>Based on your current page</ecp-list-item-subtitle>`;
                html += "</ecp-list-item-content></ecp-list-item>";
            }

            for (let j = 0; j < ApplicationObj.HelpResources.length; j++) {
                const HelpResourcesObj = ApplicationObj.HelpResources[j];
                const Url = `Home?DashboardID=184447&HelpResourcesID=${HelpResourcesObj.HelpResourcesID}&`;

                html += "<ecp-list-item>";
                html += "<ecp-list-item-content>";
                html += `<ecp-list-item-title title="${HelpResourcesObj.Notes}"><a href="${Url}">${HelpResourcesObj.Title}</a></ecp-list-item-title>`;

                if (!EC_Fmt.isNull(search)) {
                    html += `<ecp-list-item-subtitle>${ApplicationObj.Application}</ecp-list-item-title>`;
                }

                html += "</ecp-list-item-content>";
                html += `<ecp-list-item-action><a href="${Url}" target=_blank class=ews-icon-externallink></a></ecp-list-item-action>`;
                html += "</ecp-list-item>";
            }
        }
    } else {
        let title;
        let message;

        if (EC_Fmt.isNull(search)) {
            title = "Search help resources";
            message = "Use the box above to find a help resource and get started.";
        } else {
            title = "No resources found";
            message = "There aren’t any resources that match your search. Try adjusting your search, or browse all help resources using the link below.";
        }

        let emptyHtml = "<ecp-empty illustration=search>"
            + `<ecp-empty-title>${title}</ecp-empty-title>`
            + `<ecp-empty-body>${message}</ecp-empty-body>`;

        if (!EC_Fmt.isNull(search)) {
            emptyHtml += "<div>"
                + "<ecp-btn type=secondary class=ecp-help-clear>Clear search</ecp-btn>"
                + "<ecp-btn type=primary href=Home?DashboardID=184447&>Browse all help resources</ecp-btn>"
                + "</div>";
        }

        emptyHtml += "</ecp-empty>";

        helpEmpty.innerHTML = emptyHtml;
    }

    if (AvailableResourceLength > 0 && (EC_Fmt.isNull(search) || (ResourceResult && ResourceResult.length > 0))) {
        let title;
        let Url;

        if (ResourceResult && ResourceResult.length > 0) {
            title = `+${AvailableResourceLength} more relevant resources`;

            let queryString = "";

            if (!EC_Fmt.isNull(search)) {
                queryString = `SearchStr=${encodeURIComponent(search)}`;
            } else if (ApplicationID > 0) {
                queryString = `ApplicationID=${ApplicationID}`;
            }

            Url = `Home?DashboardID=184447&${queryString}`;
        } else {
            title = `${AvailableResourceLength} total resources available`;
            Url = "Home?DashboardID=184447&";
        }

        html += "<ecp-list-item style=\"background-color:#D9E7E8;font-weight:700;padding:12px 16px\">"
            + `<ecp-list-item-title>${title}</ecp-list-item-title>`
            + `<ecp-list-item-action><a href="${Url}" target=_blank><span style=padding-right:8px>View all</span><i class=ews-icon-externallink></a></ecp-list-item-action>`
            + "</ecp-list-item>";
    }

    helpContent.innerHTML = html;

    if (helpEmpty.querySelector(".ecp-help-clear")) {
        helpEmpty.querySelector(".ecp-help-clear").addEventListener("click", () => {
            document.querySelector("#ecp-help-dialog-input").value = "";
            document.querySelector("#ecp-help-dialog-input input").value = "";
            WriteCurrentHelpResources();
        });
    }

    ECP.Dialog.HideLoading();
}
